module.exports = __webpack_public_path__ + "img/Right_menu.35f7698a.png";